<template>
  <ElButton
    type="danger"
    plain
    icon="el-icon-delete"
    :size="size"
    :loading="isLoading"
    v-bind="$attrs"
    @click.native.prevent="deleteAction"
  >
    <slot />
  </ElButton>
</template>
<script>
export default {
  name: 'DeleteButton',
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    size: {
      default: 'mini',
      type: String,
    },
  },
  computed: {
    buttonSize() {
      if (this.size === 'large') {
        // to get largest size of button in elementUI, we should pass size undefined
        return undefined;
      }
      return this.size;
    },
  },
  methods: {
    deleteAction() {
      this.$emit('click');
    },
  },
};
</script>
